import { Map, Set } from "immutable";
import { ofType } from "redux-observable";
import {
  bufferCount,
  debounceTime,
  filter,
  map as mapOp,
  mergeMap,
  withLatestFrom,
  startWith,
  concat,
} from "rxjs/operators";
import _ from "lodash";
import { from, of } from "rxjs";
import { webSocket } from "rxjs/webSocket";
import { INDICATORS_LOADED, CHANGE_VALUE } from "../filters/ducks";

import createReducer from "../util/createReducer";

const ADD_FEATURE_DATA = "vgde/data/add-feature-data";
const ADD_FEATURE_ID = "vgde/data/add-feature-id";
const ADD_FEATURES_NAME = "vgde/data/add-features-name";
const ADD_INITIAL_CONTAINERS_COUNT = "vgde/data/ADD_INITIAL_CONTAINERS_COUNT";
const INCREMENT_LOADED_CONTAINERS_COUNT =
  "vgde/data/INCREMENT_LOADED_CONTAINERS_COUNT";
const SEND_DATA_REQUEST = "vgde/data/SEND_DATA_REQUEST";
const SEND_RESOURCES_REQUEST = "vgde/data/SEND_RESOURCES_REQUEST";
const RECEIVE_DATA_FROM_SERVER = "vgde/data/RECEIVE_DATA_FROM_SERVER";
const RECEIVE_RESOURCES_DATA = "vgde/data/RECEIVE_RESOURCES_DATA";
const CLEAR_DATA = "vgde/data/CLEAR_DATA";
const CLEAR_STATE = "vgde/data/CLEAR_STATE";
const RESET_CONTAINERS_LOADED = "vgde/data/RESET_CONTAINERS_LOADED";
const PORTION_LOADED = "vgde/data/PORTION_LOADED";
const PORTION_REQUESTED = "vgde/data/PORTION_REQUESTED";
const SET_AVAILABLE_PERIODS = "vgde/data/SET_AVAILABLE_PERIDOS";
const SET_CLOSE_STATS_PANEL = "vgde/data/SET_CLOSE_STATS_PANEL";

const initialState = Map({
  data: Map(),
  ids: Map(),
  names: Map(),
  byId: Map(),
  groups: Map(),
  containersToLoad: 0,
  containersLoaded: 0,
  minValue: 0,
  maxValue: 0,
  portionsToLoad: 0,
  portionsLoaded: 0,
  availablePeriods: [],
  closeStatsPanel: false,
});
export default createReducer(initialState, {
  [INCREMENT_LOADED_CONTAINERS_COUNT]: (state) => {
    return state.set("containersLoaded", state.get("containersLoaded") + 1);
  },
  [ADD_FEATURE_DATA]: (state, action) => {
    const {
      payload: { containerId, data },
    } = action;
    const currentData = state.get("data");
    const updatedData = currentData.set(containerId, data);
    return state.withMutations((map) => {
      const mapById = data.reduce(
        (map, resourceElement) =>
          map.set(resourceElement.resource, resourceElement),
        Map()
      );
      map.set("data", updatedData);
      map.set("byId", mapById);
    });
  },
  [RESET_CONTAINERS_LOADED]: (state) => state.set("containersLoaded", 0),
  [ADD_FEATURE_ID]: (
    state,
    { payload: { featureId, resourceId, containerId } }
  ) => {
    const ids = state.get("ids");
    const oldGroups = state.get("groups");
    const itemGroup = oldGroups.get(containerId) || Set();
    const newItemGroup = itemGroup.add(featureId);
    const newGroups = oldGroups.set(containerId, newItemGroup);
    const newIds = ids.set(resourceId, featureId);
    return state.withMutations((map) => {
      map.set("groups", newGroups);
      map.set("ids", newIds);
    });
  },
  [ADD_FEATURES_NAME]: (state, { payload: { data } }) => {
    const namesMap = data.reduce(
      (map, item) => map.set(item.id, item.name),
      Map()
    );
    const lastMap = state.get("names");
    const newMap = namesMap.mergeWith((old, newVal) => newVal, lastMap);
    return state.set("names", newMap);
  },
  [RECEIVE_DATA_FROM_SERVER]: (state, { payload: { data } }) => {
    const newStatsData = data.map((item) => ({
      currentDescription: item.currentDescription,
      currentProbability: item.currentProbability,
      currentValue: item.currentValue,
      maxValue: item.maxValue,
      maxYear: item.maxYear,
      minValue: item.minValue,
      minYear: item.minYear,
      resourceId: item._id,
      type: "stats",
      values: item.values,
    }));

    const dataMap = Map(newStatsData.map((item) => [item.resourceId, item]));
    const lastMap = state.get("data");
    const newMap = lastMap.mergeWith((oldVal, newVal) => newVal, dataMap);
    const newMin = newMap
      .toList()
      .filterNot(_.isEmpty)
      .map((item) => item.currentValue)
      .map(_.toNumber)
      .min();
    const newMax = newMap
      .toList()
      .filterNot(_.isEmpty)
      .map((item) => item.currentValue)
      .map(_.toNumber)
      .max();

    //Periodos disponibles del indicador
    let availablePeriods = [];
    newMap
      .toList()
      .filterNot(_.isNil)
      .filterNot(_.isEmpty)
      .forEach((item) => {
        item.values.forEach((val) => {
          const [years] = _.split(val, ";");
          const arrYears = _.split(years, "-");
          let year = "";

          if (Number(arrYears[0]) === Number(arrYears[1])) {
            year = arrYears[0];
          } else {
            year = years;
          }

          availablePeriods = [...new Set([...availablePeriods, year])].sort();
        });
      });

    return state.withMutations((map) => {
      map.set("minValue", newMin);
      map.set("maxValue", newMax);
      map.set("data", newMap);
      map.set("availablePeriods", availablePeriods);
    });
  },
  [RECEIVE_RESOURCES_DATA]: (state, { payload: { data } }) => {
    const newResourcesData = data.map((item) => ({
      containerName: item.containerDocument.name,
      resourceId: item.id,
      resourceName: item.name,
      type: "resources",
    }));
    const dataMap = Map(
      newResourcesData.map((item) => [item.resourceId, item])
    );
    const lastMap = state.get("names");
    const newMap = lastMap.merge(dataMap);
    return state.set("names", newMap);
  },
  [ADD_INITIAL_CONTAINERS_COUNT]: (state, { payload: { count } }) =>
    state.set("containersToLoad", count),
  [CLEAR_DATA]: (state) => {
    const cleanData = state.get("data").map((item) => ({}));
    return state.withMutations((map) => {
      map.set("data", cleanData);
      map.set("portionsToLoad", 0);
      map.set("portionsLoaded", 0);
    });
  },
  [PORTION_LOADED]: (state) => {
    return state.set("portionsToLoad", state.get("portionsToLoad") + 1);
  },
  [PORTION_REQUESTED]: (state) => {
    return state.set("portionsLoaded", state.get("portionsLoaded") + 1);
  },
  [CLEAR_STATE]: () => initialState,
  [SET_AVAILABLE_PERIODS]: (state, { payload: { data } }) => {
    return state.set("availablePeriods", data);
  },
  [SET_CLOSE_STATS_PANEL]: (state, { payload: { data } }) => {
    return state.set("closeStatsPanel", data);
  },
});

export function setCloseStatsPanel(data) {
  return {
    type: SET_CLOSE_STATS_PANEL,
    payload: {
      data,
    },
  };
}

export function setAvailablePeriods(data) {
  return {
    type: SET_AVAILABLE_PERIODS,
    payload: {
      data,
    },
  };
}

export function addDataContainer(containerId, data) {
  return {
    type: ADD_FEATURE_DATA,
    payload: {
      containerId,
      data,
    },
  };
}

export function addResourceId(resourceId, featureId, containerId) {
  return {
    type: ADD_FEATURE_ID,
    payload: {
      resourceId,
      featureId,
      containerId,
    },
  };
}

export function addInitialContainersCount(count) {
  return {
    type: ADD_INITIAL_CONTAINERS_COUNT,
    payload: {
      count,
    },
  };
}

export function resetContainersLoaded() {
  return {
    type: RESET_CONTAINERS_LOADED,
  };
}

export function incrementLoadedContainersCount() {
  return {
    type: INCREMENT_LOADED_CONTAINERS_COUNT,
  };
}

export function clearState() {
  return {
    type: CLEAR_STATE,
  };
}

export const initialLoadReady$ = (action$, store$) =>
  action$.pipe(
    ofType(INCREMENT_LOADED_CONTAINERS_COUNT, INDICATORS_LOADED, CHANGE_VALUE),
    debounceTime(500),
    withLatestFrom(store$),
    filter(([action, store]) => {
      const { filters, data } = store;
      const indicatorsLoaded = filters.get("indicatorsLoaded");
      const containersToLoad = data.get("containersToLoad");
      const containersLoaded = data.get("containersLoaded");

      return (
        indicatorsLoaded &&
        containersToLoad === containersLoaded &&
        containersToLoad !== 0 &&
        containersLoaded !== 0
      );
    }),
    mergeMap(() =>
      of(
        {
          type: CLEAR_DATA,
        },
        {
          type: SEND_RESOURCES_REQUEST,
        }
      )
    )
  );

function createWebSocketSubject(initialMessage, receiveAction) {
  const connection = webSocket({
    url: `wss://query.desigualdadessalud.org:18443/${initialMessage.type}`,
    openObserver: {
      next: () => {
        connection.next(initialMessage);
      },
    },
  });

  return connection.pipe(
    bufferCount(400),
    mapOp((data) => {
      return {
        type: receiveAction,
        payload: {
          data,
        },
      };
    })
  );
}

export const loadResourcesData = (action$, store$) =>
  action$.pipe(
    ofType(SEND_RESOURCES_REQUEST),
    withLatestFrom(store$),
    mergeMap(([_, store]) => {
      const ids = store.data.get("ids").toList().toArray();
      return from(ids).pipe(
        bufferCount(400),
        mergeMap((values) => {
          const message = {
            type: "resources",
            resources: values,
          };
          return createWebSocketSubject(message, RECEIVE_RESOURCES_DATA);
        }),
        concat(
          of({
            type: SEND_DATA_REQUEST,
          })
        )
      );
    })
  );

export const dataStream$ = (action$, store$) =>
  action$.pipe(
    ofType(SEND_DATA_REQUEST),
    withLatestFrom(store$),
    mergeMap(([_, store]) => {
      const filters = store.filters.toJS();
      const ids = store.data.get("ids").toList().toArray();
      return from(ids).pipe(
        bufferCount(400),
        mergeMap((values) => {
          let years = [0, 3000];
          if (filters.year !== 0 && filters.years !== []) {
            years = filters.year.split("-");
          }

          const message = {
            indicator: filters.disease,
            rangeYears: {
              upper: Number(years[0]),
              lower: Number(years[1]) ? Number(years[1]) : Number(years[0]),
            },
            typing: filters.typing,
            resources: values,
            type: "stats",
          };

          return createWebSocketSubject(message, RECEIVE_DATA_FROM_SERVER).pipe(
            startWith({ type: PORTION_REQUESTED }),
            concat(of({ type: PORTION_LOADED }))
          );
        })
      );
    })
  );



// WEBPACK FOOTER //
// ./src/components/data/ducks.js